import store from '../store';
import RawVariable from '@/layouts/variables/RawVariable';
import VariableTagTree from '@/layouts/variables/VariableTagTree';
import VariableTag from '@/layouts/variables/VariableTag';
import AggregateOperatedVariable from '@/layouts/variables/AggregateOperatedVariable';
import AggregateOperatedVariableList from '@/layouts/variables/AggregateOperatedVariableList';
import RuleList from '@/layouts/rules/RuleList';
import Rule from '@/layouts/rules/Rule';
import RuleGroupal from '@/layouts/rules/RuleGroupal';
import RuleMenu from '@/layouts/rules/RuleMenu';
import Workspace from '@/layouts/Workspace';
import EventList from '@/layouts/events/EventList';
import QueryList from '@/layouts/queries/QueryList';
import Query from '@/layouts/queries/Query';
import PermissionList from '@/layouts/groups/PermissionList';
import Settings from '@/layouts/Settings';
import GroupList from '@/layouts/groups/GroupList';
import Group from '@/layouts/groups/Group';
import GroupUserList from '@/layouts/groups/GroupUserList';
import UserList from '@/layouts/user/UserList';
import User from '@/layouts/user/User';
import GroupPermissionList from '@/layouts/groups/GroupPermissionList';
import UserProfile from '@/layouts/user/UserProfile';
import ExplorerEvolutionVariables from '@/layouts/explorer/ExplorerEvolutionVariables';
import ExplorerEvolution from '@/layouts/explorer/ExplorerEvolution';
import Explore from '@/layouts/explorer/Explore';
import ExplorerCorrelationVariables from '@/layouts/explorer/ExplorerCorrelationVariables';
import ExplorerCorrelation from '@/layouts/explorer/ExplorerCorrelation';
import ExplorerCorrelationMenu from '@/layouts/explorer/ExplorerCorrelationMenu';
import ExplorerMultipleCorrelationVariables from '@/layouts/explorer/ExplorerMultipleCorrelationVariables';
import ExplorerMultipleCorrelation from '@/layouts/explorer/ExplorerMultipleCorrelation';
import AggregateVariableMenu from '@/layouts/variables/AggregateVariableMenu';
import AggregateGradualVariable from '@/layouts/variables/AggregateGradualVariable';
import AggregateGradualVariableList from '@/layouts/variables/AggregateGradualVariableList';
import VariableManagement from '@/layouts/variables/VariableManagement';
import VariableCategory from '@/layouts/variables/VariableCategory';
import VariableCategoryList from '@/layouts/variables/VariableCategoryList';
import XugarStatus from '../layouts/XugarStatus';
import NightscoutUserList from '../layouts/NightscoutUserList';
import translationsEs from 'BRAND/i18n/es_ES/translations';
import translationsEn from 'BRAND/i18n/en_GB/translations';
import Signin from '@/layouts/Signin';
import GameRanking from 'BRAND/layouts/GameRanking';
import Legal from '@/layouts/Legal';
import ChangePassphrase from '../layouts/ChangePassphrase';
import XugarExplorer from 'BRAND/layouts/XugarExplorer';
import CsvIngest from '@/layouts/csv/CsvIngest';
import ResetPasswordMail from '@/layouts/ResetPasswordMail';
import ResetPasswordForm from '@/layouts/ResetPasswordForm';
import EmailVerification from '@/layouts/EmailVerification';
import Login from '@/layouts/Login';
import References from 'BRAND/layouts/References';
import PermissionAssignment from '@/layouts/PermissionAssignment';

export default {
  /**
   * Default locale.
   */
  locale: 'en_GB',
  /*
   * Define home root page.
   */
  home: '/xugar/status',
  /**
   * Define fallback page.
   */
  defaultFallback: '/settings',
  /**
   * Define the enabled routes
   */
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/signin',
      name: 'Signin',
      component: Signin
    },
    {
      path: '/emailverification',
      name: 'EmailVerification',
      component: EmailVerification
    },
    {
      path: '/password/reset',
      name: 'ResetPasswordMail',
      component: ResetPasswordMail
    },
    {
      path: '/password/newpassword',
      name: 'ResetPasswordForm',
      component: ResetPasswordForm
    },
    {
      path: '/legal',
      name: 'Legal',
      component: Legal
    },
    {
      path: '/references',
      name: 'References',
      component: References
    },
    {
      path: '/aggregate-variable/operated/list',
      name: 'AggregateOperatedVariableList',
      component: AggregateOperatedVariableList,
      meta: { feature: 'AggregateVariable' }
    },
    {
      path: '/aggregate-variable/operated',
      name: 'AggregateOperatedVariable',
      component: AggregateOperatedVariable,
      meta: { feature: 'AggregateVariable' }
    },
    {
      path: '/aggregate-variable/menu',
      name: 'AggregateVariableMenu',
      component: AggregateVariableMenu,
      meta: { feature: 'AggregateVariable' }
    },
    {
      path: '/aggregate-variable/gradual',
      name: 'AggregateGradualVariable',
      component: AggregateGradualVariable,
      meta: { feature: 'AggregateVariable' }
    },
    {
      path: '/aggregate-variable/gradual/list',
      name: 'AggregateGradualVariableList',
      component: AggregateGradualVariableList,
      meta: { feature: 'AggregateVariable' }
    },
    {
      path: '/rule/list',
      name: 'RuleList',
      component: RuleList,
      meta: { feature: 'Rule' }
    },
    {
      path: '/rule',
      name: 'Rule',
      component: Rule,
      meta: { feature: 'Rule' }
    },
    {
      path: '/groupal-rule',
      name: 'RuleGroupal',
      component: RuleGroupal,
      meta: { feature: 'Rule' }
    },
    {
      path: '/rule/add',
      name: 'RuleMenu',
      component: RuleMenu,
      meta: { feature: 'Rule' }
    },
    {
      path: '/workspace',
      name: 'Workspace',
      component: Workspace,
      meta: { feature: 'Workspace' }
    },
    {
      path: '/event/list',
      name: 'EventList',
      component: EventList,
      meta: { feature: 'EventList' }
    },
    {
      path: '/query/list',
      name: 'QueryList',
      component: QueryList,
      meta: { feature: 'Query' }
    },
    {
      path: '/query',
      name: 'Query',
      component: Query,
      meta: { feature: 'Query' }
    },
    {
      path: '/:type/:id/permission/list',
      name: 'Permissions',
      component: PermissionList,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings
    },
    {
      path: '/group/list',
      name: 'GroupList',
      component: GroupList,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/group',
      name: 'Group',
      component: Group,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/group/user/list',
      name: 'GroupUserList',
      component: GroupUserList,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/user/list',
      name: 'UserList',
      component: UserList,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/user',
      name: 'User',
      component: User,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/group/permission/list',
      name: 'GroupPermissionList',
      component: GroupPermissionList,
      meta: { feature: 'UsersGroupsAndPermissions' }
    },
    {
      path: '/user-profile',
      name: 'UserProfile',
      component: UserProfile
    },
    {
      path: '/explore',
      name: 'Explore',
      component: Explore,
      meta: { feature: 'Explore' }
    },
    {
      path: '/explorer-evolution-variables',
      name: 'ExplorerEvolutionVariables',
      component: ExplorerEvolutionVariables,
      meta: { feature: 'Explore' }
    },
    {
      path: '/explorer-evolution',
      name: 'ExplorerEvolution',
      component: ExplorerEvolution,
      meta: { feature: 'Explore' }
    },
    {
      path: '/explorer-correlation-variables',
      name: 'ExplorerCorrelationVariables',
      component: ExplorerCorrelationVariables,
      meta: { feature: 'Explore' }
    },
    {
      path: '/explorer-correlation',
      name: 'ExplorerCorrelation',
      component: ExplorerCorrelation,
      meta: { feature: 'Explore' }
    },
    {
      path: '/explorer-correlation/menu',
      name: 'ExplorerCorrelationMenu',
      component: ExplorerCorrelationMenu,
      meta: { feature: 'ExplorerCorrelationBenchmark' }
    },
    {
      path: '/explorer-multiple-correlation-variables',
      name: 'ExplorerMultipleCorrelationVariables',
      component: ExplorerMultipleCorrelationVariables,
      meta: { feature: 'Explore' }
    },
    {
      path: '/explorer-multiple-correlation',
      name: 'ExplorerMultipleCorrelation',
      component: ExplorerMultipleCorrelation,
      meta: { feature: 'Explore' }
    },
    {
      path: '/raw-variable',
      name: 'RawVariable',
      component: RawVariable,
      meta: { feature: 'RawVariable' }
    },
    {
      path: '/tags-tree',
      name: 'VariableTagTree',
      component: VariableTagTree,
      meta: { feature: 'Admin' }
    },
    {
      path: '/tags',
      name: 'VariableTag',
      component: VariableTag,
      meta: { feature: 'Admin' }
    },
    {
      path: '/variable-management',
      name: 'VariableManagement',
      component: VariableManagement,
      meta: { feature: 'Admin' }
    },
    {
      path: '/categorical-variable',
      name: 'VariableCategory',
      component: VariableCategory,
      meta: { feature: 'Admin' }
    },
    {
      path: '/categorical-variable/list',
      name: 'VariableCategoryList',
      component: VariableCategoryList,
      meta: { feature: 'Admin' }
    },
    {
      path: '/xugar/status',
      name: 'XugarStatus',
      component: XugarStatus
    },
    {
      path: '/xugar/nightscout/user/list',
      name: 'NightscoutUserList',
      component: NightscoutUserList,
      meta: { feature: 'NightscoutUserList' }
    },
    {
      path: '/xugar/nightscout/user/changepassphrase',
      name: 'ChangePassphrase',
      component: ChangePassphrase
    },
    {
      path: '/xugarhero/game/ranking',
      name: 'GameRanking',
      component: GameRanking
    },
    {
      path: '/xugarhero/explorer',
      name: 'XugarExplorer',
      component: XugarExplorer
    },
    {
      path: '/csv-uploader',
      name: 'CsvIngest',
      component: CsvIngest,
      meta: {feature: 'Superadmin'}
    },
    {
      path: '/permission-assignment',
      name: 'PermissionAssignment',
      component: PermissionAssignment,
      meta: {feature: 'PermissionAssignment'}
    }
  ],
  featurePermission: [
    {
      feature: 'Superadmin',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'Explorer',
      authorities: ['ROLE_ADMIN', 'EXPLORER']
    },
    {
      feature: 'Explore',
      authorities: ['ROLE_ADMIN', 'EXPLORER']
    },
    {
      feature: 'ExplorerCorrelationBenchmark',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'Taxonomy',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'Dashboard',
      authorities: ['ROLE_ADMIN', 'DASHBOARD']
    },
    {
      feature: 'Market',
      authorities: ['ROLE_ADMIN', 'MARKET']
    },
    {
      feature: 'Consultas',
      authorities: ['ROLE_ADMIN', 'LEVELSANDRHYTHMS']
    },
    {
      feature: 'AggregateVariable',
      authorities: ['ROLE_ADMIN', 'AGGREGATEVAR']
    },
    {
      feature: 'Query',
      authorities: ['ROLE_ADMIN', 'QUERY']
    },
    {
      feature: 'Rule',
      authorities: ['ROLE_ADMIN', 'RULE']
    },
    {
      feature: 'RawVariable',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'UsersGroupsAndPermissions',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'Workspace',
      authorities: ['ROLE_SUPERADMIN', 'ROLE_ADMIN', 'RULE', 'AGGREGATEVAR', 'QUERY']
    },
    {
      feature: 'EventList',
      authorities: ['ROLE_ADMIN', 'RULE']
    },
    {
      feature: 'NightscoutUserList',
      authorities: ['ROLE_ADMIN']
    },
    {
      feature: 'PermissionAssignment',
      authorities: ['ROLE_SUPERADMIN']
    },
    {
      feature: 'Admin',
      authorities: ['ROLE_ADMIN']
    }
  ],
  /**
   * Define the main menu entries.
   */
  mainMenuEntries: [
    {
      routeName: 'XugarStatus',
      label: 'xugarhero.status'
    },
    {
      routeName: 'Explore',
      label: 'menu.explorer'
    },
    {
      routeName: 'GameRanking',
      label: 'xugarhero.game.ranking'
    },
    {
      routeName: 'XugarExplorer',
      label: 'xugarhero.explorer.title'
    },
    {
      routeName: 'NightscoutUserList',
      label: 'xugarhero.nightScout'
    },
    {
      routeName: 'ChangePassphrase',
      label: 'xugarhero.changePassphrase.title'
    }
  ],
  /**
   * Define the assignable permissions.
   */
  assignablePermissions: [
    {
      name: 'explorer',
      label: 'menu.explorer',
      children: [
        {
          name: 'query',
          label: 'menu.queries'
        }
      ]
    },
    {
      name: 'rule',
      label: 'group.permissions.rulesAndEvents'
    },
    {
      name: 'aggregateVar',
      label: 'group.permissions.aggregateVariable'
    }
  ],
  /**
   * Define the initial date filter time lapse on explorer layout.
   * It is used to set the initial date filter values. Mandatory if explorer is enabled.
   */
  explorerDefaultDate: {
    startOf: 'day',
    unit: 'd',
    gapBegin: 7,
    gapEnd: 0
  },
  /**
   * Minimal selectable date into explorer filter. Optional.
   */
  minDate: new Date('2013-12-31 00:00:00+2:00'),
  /**
   * Google Analytics tracking code.
   */
  trackingCode: 'UA-138016600-4',
  /**
   * Store modules.
   */
  modules: store.modules,
  /**
   * Translations.
   */
  i18n: {
    es_ES: translationsEs,
    en_GB: translationsEn
  },
  /**
   * Term and conditions i18n key.
   */
  termAndConditions: 'legal-termAndConditions',
  privacyPolicy: 'legal-privacyPolicy'
};



// WEBPACK FOOTER //
// ./src/brand/xugarhero/config/index.js